import React from "react";

const Input = ({ value, onChange, placeholder = "" }) => {
  return (
    <input
      className="searchNodeInput border p-2 rounded w-full"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
    />
  );
};

export default Input;
